import { useLocation } from "react-router-dom";
import { ReactNode, useEffect, useState } from "react";

export function PageTransition({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [shown, setShown] = useState(true);

  useEffect(() => {
    setShown(false);
    const id = requestAnimationFrame(() => setShown(true));
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return (
    <div
      key={pathname}
      className={`transition-all duration-500 [transition-timing-function:var(--ease-out-quart)] ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      }`}
    >
      {children}
    </div>
  );
}